import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import { useCallback } from 'react';
import { PowerPlayerBolt } from '../assets/powerPlayerBolt';
import { ExpandableSection } from '../components/expandableSection';
import { isConfigFlagEnabled } from '../config';
import { InfoIcon } from '../icons/infoIcon';
import { thunkGoToGameGuidePage } from '../redux/actions/gameGuideActions';
import { addMessageBox } from '../redux/actions/messageBoxesActions';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { DrawerButton } from './drawerButton';
import { ExpandableSectionPaddedDrawerContainer } from './drawerControl';
export const GameInfoExpandableDrawerSection = ({ closeDrawer }) => {
    const isPowerPlayer = useAppSelector((state) => state.selfData.isPowerPlayer);
    const dispatch = useAppDispatch();
    const onClickGameGuide = useCallback(() => {
        dispatch(thunkGoToGameGuidePage());
        closeDrawer();
    }, [closeDrawer, dispatch]);
    const onClickNews = useCallback(() => {
        dispatch(addMessageBox({ type: 'news' }));
        closeDrawer();
    }, [closeDrawer, dispatch]);
    const onClickPowerPlayerPerks = useCallback(() => {
        closeDrawer();
        dispatch(thunkGoToGameGuidePage('power-player'));
    }, [closeDrawer, dispatch]);
    const onClickCommunity = useCallback(() => {
        dispatch(addMessageBox({ type: 'community' }));
        closeDrawer();
    }, [closeDrawer, dispatch]);
    return (_jsx(ExpandableSection, { expandableSectionType: 'drawer-game-info', colorType: 'drawer', children: _jsxs(ExpandableSectionPaddedDrawerContainer, { children: [_jsx(DrawerButton, { label: 'Game Guide', onClick: onClickGameGuide, startIcon: _jsx(InfoIcon, {}) }), _jsx(DrawerButton, { label: 'News', onClick: onClickNews, startIcon: _jsx(CampaignRoundedIcon, {}) }), !isPowerPlayer && (_jsx(DrawerButton, { label: 'Power Player Perks', onClick: onClickPowerPlayerPerks, startIcon: _jsx(PowerPlayerBolt, { color: 'yellow' }) })), isConfigFlagEnabled('showCommunityModal') && (_jsx(DrawerButton, { label: 'Community / Support', onClick: onClickCommunity }))] }) }));
};
